//import { Component, ElementRef, OnInit } from '@angular/core'
//import { ActivatedRoute, Router } from '@angular/router'
//import { UntypedFormControl } from '@angular/forms'
//import { NotesTemplateService } from '../../../../api/services/notes-template.service'
//import { DataPageOfNotesTemplate, NotesTemplate } from '../../../../api/models'
//import { ConfirmationService, MessageService } from 'primeng/api'
//import { startWith } from 'rxjs'

//@Component({
//  selector: 'app-manage-notes',
//  templateUrl: './manage-notes.component.html',
//  styleUrls: [],
//})
//export class ManageNotesComponent implements OnInit {
//  cols: (
//    | { field: string; header: string; Header?: undefined }
//    | { Header: string; field: string; header?: undefined }
//  )[]
//  notesList: DataPageOfNotesTemplate
//  categoriesList: any[]
//  categoryControl = new UntypedFormControl()
//  showRecords: boolean = false
//  rows: number
//  selectedNotes: NotesTemplate
//    first = 0
//    categoryId;
//  constructor(
//    private messageService: MessageService,
//    private confirmation: ConfirmationService,
//    private notesTemplateService: NotesTemplateService,
//    private router: Router,
//    private activatedRoute: ActivatedRoute,
//  ) {}

//  ngOnInit() {
//    this.cols = [
//      { field: 'notesCategoryName', header: 'Category Name' },
//      { field: 'templateName', header: 'Template Name' },
//      { header: 'Description', field: 'description' },
//    ]


//      this.categoryId = this.activatedRoute.snapshot.queryParams.category_id;
//      alert(this.categoryId);
//      this.loadCategories();

//    this.categoryControl.valueChanges
//      .pipe(startWith({ categoryId: '' }))
//      .subscribe((value) => {
//          console.log(value);
//        this.notesTemplateService
//          .notesTemplateFindAll({ CategoryId: value?.categoryId })
//          .subscribe((result) => {
//            this.notesList = result

//            this.rows = this.notesList.pageSize
//            if (result.data.length > 0) {
//              this.showRecords = true
//            } else {
//              this.showRecords = false
//            }
//          })
//      })

//    if (this.categoryId) {
//      //alert("ssss");
//      this.notesTemplateService
//        .notesTemplateFindAll({ CategoryId: this.categoryId })
//        .subscribe((result) => {
//          this.notesList = result

//          this.rows = this.notesList.pageSize
//          debugger
//          if (result.data.length > 0) {
//            this.showRecords = true
//          } else {
//            this.showRecords = false
//          }
//        })
//      }


//  }

//  onAddNotesTemplate(): void {
//    console.log(this.categoryControl.value)
//    this.router.navigate([
//      'administration',
//      'add-notes',
//      this.categoryControl.value.categoryId,
//      this.categoryControl.value.categoryName,
//      'new',
//    ])
//  }

//  onEditNote(rowData: NotesTemplate): void {
//    console.log(rowData)
//    this.router.navigate(['administration', 'edit-notes', rowData.notesTemplateId], { relativeTo: null })
//  }

//  onCloneNote(rowData: NotesTemplate) {
//    this.router.navigate(['administration', 'add-notes', rowData.notesCategoryId, rowData.notesCategoryName,  rowData.notesTemplateId])
//  }

//  onDeleteNote(event, rowData: NotesTemplate) {
//    this.confirmation.confirm({
//      key: 'delete_confirmation',
//      message: 'Are you sure you want to delete this note?',
//      accept: () => {
//        this.deleteNotes(rowData.notesTemplateId)
//      },
//    })
//    }




//  loadCategories() {
//    this.notesTemplateService
//      .notesTemplateGetAllcategories({})
//        .subscribe((result) => {
//            const categoryId = this.activatedRoute.snapshot.queryParams.category_id
//            if (this.categoryId == 'undefind' || this.categoryId == null) {
//                this.categoriesList = result
//            }
//            else {

//                this.categoriesList = result;
//                this.categoriesList = this.categoriesList.filter(x => x.categoryId == categoryId);
//            }



//        if (!categoryId) {
//          // alert(categoryId)
//          //   this.categoryControl.setValue(this.categoriesList[0]);
//        } else {
//          // alert(categoryId)
//          this.categoryControl.setValue(categoryId)
//        }

//          const c = this.categoriesList.find((item) => item.categoryId === categoryId);
//        if (categoryId) {
//          // alert(categoryId)
//          this.categoryControl.setValue(c)
//        }
//      })
//  }



//  deleteNotes(id) {
//    this.notesTemplateService.notesTemplateDelete({ id }).subscribe((data) => {
//      this.messageService.add({
//        key: 'alertToast',
//        severity: 'success',
//          summary: 'Confirmation',
//          detail: ' Note Deleted Successfully',
//      })

//      //this.notesTemplateService.notesTemplateFindNotesByCategory({ categoryId: this.categoryControl.value.categoryId })
//      //    .subscribe(result => {
//      //        this.notesList = result;
//      //    })

//      this.notesTemplateService
//        .notesTemplateFindAll({
//          CategoryId: this.categoryControl.value?.categoryId,
//        })
//        .subscribe((result) => {
//          this.notesList = result

//            this.rows = this.notesList.pageSize
//            this.first = 0;
//          debugger
//          if (result.data.length > 0) {
//            this.showRecords = true
//          } else {
//            this.showRecords = false
//          }
//        })
//    })
//  }

//  selectAllCategories() {
//    this.categoryControl.setValue(null)

//    this.notesTemplateService
//      .notesTemplateFindAll({ CategoryId: null })
//      .subscribe((result) => {
//        this.notesList = result

//        this.rows = this.notesList.pageSize
//        debugger
//        if (result.data.length > 0) {
//          this.showRecords = true
//        } else {
//          this.showRecords = false
//        }
//      })
//    // alert("bbbbb");
//  }
//}


import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormControl } from '@angular/forms';
import { NotesTemplateService } from '../../../../api/services/notes-template.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { startWith } from 'rxjs';

@Component({
    selector: 'app-manage-notes',
    templateUrl: './manage-notes.component.html',
})
export class ManageNotesComponent implements OnInit {

    cols: any[];
    notesList: any;
    categoriesList: any[] = [];
    categoryControl = new UntypedFormControl(null);

    rows = 10;
    first = 0;
    showRecords = false;
    selectedNotes: any;
    categoryId: any;

    constructor(
        private notesTemplateService: NotesTemplateService,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private messageService: MessageService,
        private confirmation: ConfirmationService
    ) { }

    ngOnInit(): void {

        this.cols = [
            { field: 'notesCategoryName', header: 'Category Name' },
            { field: 'templateName', header: 'Template Name' },
            { field: 'description', header: 'Description' },
        ];

        // Read category from URL
        this.categoryId = this.activatedRoute.snapshot.queryParams['category_id'];

        this.loadCategories();

        // React to dropdown change
        this.categoryControl.valueChanges
            .pipe(startWith(null))
            .subscribe(category => {
                const categoryId = category?.categoryId ?? null;
                this.loadNotes(categoryId);
            });
    }

    loadCategories(): void {
        this.notesTemplateService
            .notesTemplateGetAllcategories({})
            .subscribe(result => {

                this.categoriesList = result;

                if (this.categoryId) {
                    const selected = this.categoriesList.find(
                        c => c.categoryId == this.categoryId
                    );
                    if (selected) {
                        this.categoryControl.setValue(selected);
                    }
                }
            });
    }

    loadNotes(categoryId: any): void {
        this.notesTemplateService
            .notesTemplateFindAll({ CategoryId: categoryId })
            .subscribe(result => {
                this.notesList = result;
                this.rows = result.pageSize;
                this.first = 0;
                this.showRecords = result.data?.length > 0;
            });
    }

    selectAllCategories(): void {
        this.categoryControl.setValue(null);
    }

    onAddNotesTemplate(): void {
        const c = this.categoryControl.value;
        this.router.navigate([
            'administration',
            'add-notes',
            c.categoryId,
            c.categoryName,
            'new',
        ]);
    }

    onEditNote(row: any): void {
        this.router.navigate(['administration', 'edit-notes', row.notesTemplateId]);
    }

    onCloneNote(row: any): void {
        this.router.navigate([
            'administration',
            'add-notes',
            row.notesCategoryId,
            row.notesCategoryName,
            row.notesTemplateId,
        ]);
    }

    onDeleteNote(event: any, row: any): void {
        this.confirmation.confirm({
            key: 'delete_confirmation',
            message: 'Are you sure you want to delete this note?',
            accept: () => {
                this.notesTemplateService
                    .notesTemplateDelete({ id: row.notesTemplateId })
                    .subscribe(() => {
                        this.messageService.add({
                            key: 'alertToast',
                            severity: 'success',
                            summary: 'Confirmation',
                            detail: 'Note Deleted Successfully',
                        });

                        this.loadNotes(this.categoryControl.value?.categoryId);
                    });
            },
        });
    }
}

